module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre23"
  }, [_c('span', {
    staticClass: "calibre8"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("A special thanks to my publisher, Debi Stanton, for her assistance in getting this book published.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre25"
  }, [_c('span', {
    staticClass: "calibre8"
  }, [_vm._v("Thank you to all who helped by reading, editing, and offering suggestions, especially Gail O’Connor, Elijah Knipp, Billy Jean Weinert, and Melissa and Philip Festervand.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Thank you to my friend, Eldon Orme, who rode the Pony Express trail and provided materials that were very helpful.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Thank you to my wonderful and supportive husband, Leonard Srch, who proofreads each revision, and thank you to my three sons, Andrew, Benjamin, and Christopher, who have learned to deal with Mom’s creative moods!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I love you dearly!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre22"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54396cd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0003.vue
// module id = 69
// module chunks = 0